import React, { Component } from 'react';
import { I18n } from 'aws-amplify';
import { TitleMiddleLine } from '../../components/Titles';
import constants from "../../../constants";
import styled from 'styled-components';

import {
    Row,
    Col,
    Button,
    Checkbox,
    Input,
    Select,
    Form
} from 'antd';


const { TextArea } = Input;
const { Option } = Select;


const RowSubmitModal = styled(Row)`
  border-top: solid 1px #ccc;
  margin-top: 30px;
  padding-top: 20px;
  button {
      margin-right: 20px;
  }
`;

class FormLeaders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formState: []
        }
    }


    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.setState({
                    formState: values,
                })
                
                let expertise = values.expertise ? JSON.parse(values.expertise) : null;

                let data = {
                    ...values,
                    partnerId: this.props.partnerId,
                    expertise: expertise
                }


                if (this.props.item) {
                    data.id = this.props.item.id;
                    this.props.update(data);

                } else {
                    this.props.action(data);
                }
            }
        });

    };

    componentDidUpdate(prevProps, prevState) {

        if (!prevProps) return;
        if (!prevState) return;

        if (this.props.errors != prevProps.errors && this.props.errors) {
            Object.keys(this.props.errors).map(field => {
                this.props.form.setFields({
                    [field]: {
                        value: this.state.formState[field],
                        errors: [new Error(this.props.errors[field].errorMessage)],
                    },
                });
            });
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const { partner } = this.props;

        return (
            <Form onSubmit={this.handleSubmit}>
                <Row className="RowSection">
                    <Col sm={12}>
                        <Form.Item label={I18n.get("Nome")}>
                            {getFieldDecorator('name', {
                                rules: [{ required: false, message: 'Campo obrigatório!' }],
                                initialValue: this.props.item && this.props.item.name ? this.props.item.name : null
                            })(
                                <Input

                                />
                            )}
                        </Form.Item>
                    </Col>
                    <Col sm={12}>
                        <Form.Item label={I18n.get("E-mail")}>
                            {getFieldDecorator('email', {
                                rules: [{ required: false, message: 'Campo obrigatório!' }],
                                initialValue: this.props.item && this.props.item.email ? this.props.item.email : null
                            })(
                                <Input

                                />
                            )}
                        </Form.Item>
                    </Col>
                    <Col sm={12}>
                        <Form.Item label={I18n.get("Função")}>
                            {getFieldDecorator('expertise', {
                                rules: [{ required: false, message: 'Campo obrigatório!' }],
                                initialValue: this.props.item && this.props.item.expertise ? JSON.stringify(this.props.item.expertise) : null
                            })(
                                <Select
                                    style={{ width: "100%" }}
                                    showSearch={true}
                                >
                                    {this.props.expertise && this.props.expertise.map((item) => {
                                        return <Option key={item.code} value={JSON.stringify(item)}>{item.label}</Option>
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>


                </Row>
                <RowSubmitModal>
                    <Col sm={24}>

                        <Button shape="round" onClick={() => this.props.cancel()}>{I18n.get("Cancelar")}</Button>

                        <Button type="primary" shape="round" htmlType="submit">
                            {this.props.item ? I18n.get("Atualizar") : I18n.get("Adicionar")}
                        </Button>
                    </Col>
                </RowSubmitModal>
            </Form>
        );
    }
}

const FormLeadersForm = Form.create({})(FormLeaders);

export default FormLeadersForm;
